import Help from '@admin/components/help'
import PropTypes from 'prop-types'
import React from 'react'

class HelpPage extends React.Component {

  static contextTypes = {
    router: PropTypes.object
  }

  _handleBack = this._handleBack.bind(this)

  render() {
    return <Help { ...this._getHelp() } />
  }

  _getHelp() {
    return {
      onBack: this._handleBack
    }
  }

  _handleBack() {
    this.context.router.goBack()
  }

}

export default HelpPage
